import React from 'react'

/**
 * 创建无状态组件
 * 应该使用函数而不是 ES6 匿名函数(=>)，否则会增加调试的难度(比如分析内存占用或者显示出错信息的时候会显示 anonymous)
 * */
function Image(props) {
  const { src, title, alt, caption, width, height } = props
  //
  function setSectionBgStyles(e) {
    $(e.target).parents('.site-section').addClass('with-bg').css({
      backgroundImage: `url(${src})`
    }).end().parents('figure').hide()
  }
  //
  if (props.asHero) {
    //$('body').addClass('with-hero-section')
  }
  //
  return (
    <figure className={props.className}>
      <img src={ src }
           alt={ alt || title || caption }
           onLoad={ (e) => {if (props.asBg) setSectionBgStyles(e) } }
           title={ title || caption } />
      {
        caption ?
        <figcaption>
          { caption }
        </figcaption> :
        null
      }
    </figure>
  )
}

export default Image


// WEBPACK FOOTER //
// ./app/javascript/app/site/components/content/media/image/index.js